<template>
  <div class="container_axis">
    <div class="main-box">
      <div class="main-warp" v-for="(item,index) in list" :key="index">
        <div class="show-time">
          <i class="el-icon-time"></i>
          <span>{{ $formart(item.date) }}</span>
        </div>
        <div class="user-warp" v-for="(val,i) in item.list " :key="i">
          <div class="user-item">
            <div class="time-line">{{ $formart(val.examineDate,'hh:mm:ss') }}</div>
            <div class="point-gap">
              <div class="point-line" :class="{'active-line':i==0}"></div>
              <div class="point-circle"></div>
              <div class="point-line" :class="{'active-line':i== item.list.length-1}"></div>
            </div>
            <div class="user-detail">
              <img v-if="val.userhead" :src="imgShow+val.userhead" alt />
              <img v-else src="/static/img/defaultHeadImg.png" alt="">
              <div class="name-box mr5">
                <span class="name">{{ val.name }}</span>
              </div>
              <div class="event event-reject">驳回</div>
              <div class="company">{{ val.problem }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  created() {},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang='less' scoped>
.container_axis {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-box {
  width: 100%;
  height: 100%;
  background: #F9F9F9;
  padding: 15px;
  .main-warp {
    margin-top: 5px;
    .show-time {
      width: 120px;
      height: 20px;
      padding: 2px 6px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(22, 119, 255, 0.1);
      border-radius: 4px;
      i {
        color: #1677ff;
        margin-right: 3px;
      }
    }
    .user-warp {
      .user-item {
        width: 100%;
        display: flex;
        align-items: center;
        .time-line {
          min-width: 55px;
          white-space: nowrap;
          color: #9b9b9b;
        }
        .point-gap {
          width: 50px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .point-line {
            height: 21px;
            border: 1px solid #d0d6de;
          }
          .active-line {
            border-color: white;
          }
          .point-circle {
            margin: 5px 0;
            width: 13px;
            height: 13px;
            background: #268aff;
            border-radius: 10px;
          }
        }
        .user-detail {
          width: 100%;
          display: flex;
          align-items: center;
          padding: 15px 0px;
          box-sizing: border-box;
          font-size: 14px;
          border-bottom: 1px dashed #eeeeee;
          img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            margin-right: 10px;
          }
          .name-box {
            display: flex;
            flex-direction: column;
            .name {
              color: #4a4a4a;
              margin-right: 10px;
              font-weight: bold;
              white-space: nowrap;
            }
            .companyName {
              max-width: 71px;
              color: #d0d6de;
              font-size: 12px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }

          .event {
            border-radius: 3px;
            padding: 2px 4px;
            font-size: 12px;
            color: white;
            margin-right: 10px;
            white-space: nowrap;
          }
          .event-call {
            background: #268aff;
          }
          .event-reject {
            background: #FF6010;
          }
          .type {
            color: #4a4a4a;
            margin-right: 10px;
          }
          .company {
            padding: 8px 14px 8px 4px;
            box-sizing: border-box;
            background: #f6f8fa;
            .cmmr-playacc {
              height: 18px;
            }
            .cmmr-playacc:focus {
              outline: none;
            }
            .picture-box {
              color: #268aff;
              font-size: 12px;
              cursor: pointer;
              margin-top: 3px;
              i {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
}
.img-box {
  padding-top: 15%;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/table/TimeAxis.vue